import * as React from 'react'
import { default as CategoryModel } from '../../models/category'
import { Grid } from '../../components/grid'
import './SubcategoryList.scss'
import { Link, Icon, chevron } from '../../components'
import { getCategoryUrl } from './utilities'

export type Props = {
    categories: CategoryModel[]
}

class SubcategoryList extends React.Component<Props> {
    render() {
        const { categories } = this.props

        return (
            <>
                <Grid className='subcategory-list'>
                    <div className='subcategory-list__row row'>
                        <div className='category-list__cell col-xs-12'>
                            <ul className='subcategory-list__categories'>
                                {categories.map((category, index) => (
                                    <li className='subcategory-list__item' key={category.slug}>
                                        <Link
                                            className='subcategory-list__link'
                                            to={getCategoryUrl(category.slug)}
                                            key={`subcatlist-${index}`}
                                        >
                                            <span className='subcategory-list__category-description'>
                                                {category.name}
                                            </span>
                                            <Icon icon={chevron} className='subcategory-list__category-chevron' />
                                        </Link>
                                    </li>
                                ))}
                            </ul>
                        </div>
                    </div>
                </Grid>
            </>
        )
    }
}

export default SubcategoryList
